export default __webpack_public_path__ + "static/media/banner3.fc563935.jpg";